import React, { useContext } from "react";
import { Link, withRouter, useHistory } from "react-router-dom";
import * as Icon from "react-feather";
import { MenuOutlined } from "@ant-design/icons";
import { useQuery } from "react-query";

import avatar from "../../assets/images/avatar-1.png";
import { DashboardContext } from "context/DashboardContext";
import routes from "routes";
import { api_srv } from "services";

function Nav_Content() {
  const { isToggled, setToggled } = useContext(DashboardContext);
  const history = useHistory();

  // ────────────────────────────────────────────────
  // Data Fetching
  // ────────────────────────────────────────────────
  const fetchIntermediaryDetails = async () => {
    const response = await (await api_srv).fetchIntermediaryProfile();
    return response?.data;
  };

  const {
    data: details = [],
    isLoading: detailsLoading,
    isSuccess: detailsLoaded,
  } = useQuery("profile details", fetchIntermediaryDetails);

  // const {
  //   data: notifications,
  //   isLoading: notifLoading,
  //   isSuccess: notifLoaded,
  // } = useQuery("notifications", get_notifications);

  const status = details?.[0]?.status;
  const intermediaryName = details?.[0]?.intermediaryNames || "User";

  // ────────────────────────────────────────────────
  // Handlers
  // ────────────────────────────────────────────────
  const toggleSidebar = () => setToggled(!isToggled);

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    history.push("/");
  };

  // ────────────────────────────────────────────────
  // Render
  // ────────────────────────────────────────────────
  return (
    <nav className="navbar navbar-expand-lg" style={{ background: "#f5f8ff" }}>
      {/* Left - Sidebar Toggle */}
      <ul className="list-inline d-flex justify-content-between list-unstyled mg-r-20">
        <li className="list-inline-item align-text-top">
          <a
            className="tx-20"
            href="#"
            id="collapsed-sidebar-toggle-button"
            onClick={(e) => {
              e.preventDefault();
              toggleSidebar();
            }}
          >
            <MenuOutlined />
          </a>
        </li>
      </ul>

      {/* Right Section - shown only after profile is loaded */}
      {detailsLoaded && (
        <div className="header-right pull-right ml-auto d-flex align-items-center">
          {/* Profile Status Badge */}
          <div className="mt-1 mr-3">
            {status === "ACTIVE" ? (
              <span className="badge badge-btn badge-btn-active">
                PROFILE ACTIVE!
              </span>
            ) : (
              <span className="badge badge-btn badge-btn-inactive">
                PROFILE INACTIVE!
              </span>
            )}
          </div>

          <ul className="list-inline justify-content-end mb-0">
            {/* Notifications Dropdown */}
            <li className="list-inline-item dropdown hidden-xs" style={{ background: "#f2f2f2" }}>
              <a
                className="notification-icon"
                href="#"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <Icon.Bell size={18} />
                <span className="notification-count wave in" />
              </a>

              <div className="dropdown-menu dropdown-menu-right shadow-2">
                <div className="top-notifications-area">
                  <div className="notifications-heading">
                    <div className="heading-title">
                      <h6>Notifications</h6>
                    </div>
                    <span>5+ New Notifications</span>
                  </div>

                  <div className="notifications-box" id="notificationsBox">
                    {/* Notifications would be rendered here */}
                  </div>

                  <div className="notifications-footer">
                    <a href="#">View all Notifications</a>
                  </div>
                </div>
              </div>
            </li>

            {/* Messages Dropdown */}
            <li className="list-inline-item dropdown hidden-xs">
              <a
                className="message-icon"
                href="#"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <Icon.Mail size={18} />
                <span className="messages-count wave in" />
              </a>
            </li>

            {/* Profile Dropdown */}
            <li className="list-inline-item dropdown">
              <a
                href="#"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span className="select-profile">Hi, {intermediaryName}</span>
                <img
                  src={avatar}
                  className="img-fluid wd-35 ht-35 rounded-circle"
                  alt="profile"
                />
              </a>

              <div className="dropdown-menu dropdown-menu-right dropdown-profile shadow-2">
                <div className="user-profile-area">
                  <div className="user-profile-heading">
                    <div className="profile-text">
                      <h6>{intermediaryName}</h6>
                    </div>
                  </div>

                  <Link to={routes.profile} className="dropdown-item">
                    <Icon.User size={14} className="mr-2" />
                    My profile
                  </Link>

                  <Link to={routes.reviews} className="dropdown-item">
                    <Icon.ThumbsUp size={14} className="mr-2" />
                    Reviews
                    <span className="badge badge-warning ft-right mg-t-3">5+</span>
                  </Link>

                  <div
                    className="dropdown-item"
                    onClick={handleLogout}
                    style={{ cursor: "pointer" }}
                  >
                    <Icon.Power size={14} className="mr-2" />
                    Sign-out
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}

export default withRouter(Nav_Content);